import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Divider } from '@mui/material';
import { CommentIcon } from '@sharedCR/coreDesignSystem/icons';
import InfoTitle from '@sharedCR/coreDesignSystem/InfoTitle';
import TaskThread from 'app/shared/modules/TaskThread';
import PropTypes from 'prop-types';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';
import { IconSize } from 'constants/coreDesignSystem';
import { PAGE_CODES } from 'constants/pageCodes';

import {
  getMasterPermissionsToPage,
  selectIsBrokerOrSubCompanyUser,
  selectIsClaimAllowed,
} from 'store/auth/selectors';

import { TASK_THREAD_TITLE } from './TaskInfoThread.constants';

// Internal sessions only until the staff history read is audience-scoped server-side (DEV-6641).
const TaskInfoThread = ({ taskId, isLocked = false }) => {
  const isBrokerOrSubCompanyUser = useSelector(selectIsBrokerOrSubCompanyUser);
  const { isEditAllowed } = useSelector(getMasterPermissionsToPage(PAGE_CODES.TASKS));
  const isApproveRejectCancelAllowed = useSelector(
    selectIsClaimAllowed(COMPOSED_CLAIMS.APPROVE_REJECT_CANCEL_TASK),
  );

  if (isBrokerOrSubCompanyUser) {
    return null;
  }

  return (
    <>
      <Divider />
      <Box>
        <InfoTitle
          className="mb-16"
          icon={<CommentIcon size={IconSize[16]} />}
          title={TASK_THREAD_TITLE}
        />
        <TaskThread
          canViewAllAudiences
          canChooseAudience={isApproveRejectCancelAllowed}
          canPost={isEditAllowed && !isLocked}
          taskId={taskId}
        />
      </Box>
    </>
  );
};

TaskInfoThread.propTypes = {
  taskId: PropTypes.string.isRequired,
  isLocked: PropTypes.bool,
};

export default memo(TaskInfoThread);
